import { Nullable } from '../helpers'

/**
 * Mirrors backend-platform `GuidelineDTO` returned by `GET /guidelines`
 * (ISSUE-1675). One entry per Notion guideline available to the creative.
 */
export interface GuidelineDTO {
  id: string
  title: string
  productId: Nullable<string>
  category: Nullable<string>
  language: string
  sortOrder: number
}

/**
 * Mirrors backend-platform `GuidelinePageDTO` returned by
 * `GET /guidelines/{productKind}` (ISSUE-1675). Full Notion page content
 * rendered as a tree of structured blocks (no iframe).
 */
export interface GuidelinePageDTO {
  id: string
  title: string
  productId: Nullable<string>
  category: Nullable<string>
  language: string
  blocks: GuidelineBlockDTO[]
}

export interface GuidelineBlockDTO {
  id: string
  type: GuidelineBlockType
  content: Nullable<GuidelineBlockContentDTO>
  children: GuidelineBlockDTO[]
}

export enum GuidelineBlockType {
  PARAGRAPH = 'PARAGRAPH',
  HEADING_1 = 'HEADING_1',
  HEADING_2 = 'HEADING_2',
  HEADING_3 = 'HEADING_3',
  BULLETED_LIST_ITEM = 'BULLETED_LIST_ITEM',
  NUMBERED_LIST_ITEM = 'NUMBERED_LIST_ITEM',
  TO_DO = 'TO_DO',
  CALLOUT = 'CALLOUT',
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  YOUTUBE = 'YOUTUBE',
  TABLE = 'TABLE',
  TABLE_ROW = 'TABLE_ROW',
  DIVIDER = 'DIVIDER',
  COLUMN_LIST = 'COLUMN_LIST',
  COLUMN = 'COLUMN',
  SLIDESHOW = 'SLIDESHOW',
  BEFORE_AFTER = 'BEFORE_AFTER',
  UNKNOWN = 'UNKNOWN',
}

export interface GuidelineBlockContentDTO {
  richText: Nullable<GuidelineRichTextDTO[]>
  checked: Nullable<boolean>
  icon: Nullable<string>
  color: Nullable<string>
  imageUrl: Nullable<string>
  videoUrl: Nullable<string>
  youtubeVideoId: Nullable<string>
  tableWidth: Nullable<number>
  hasColumnHeader: Nullable<boolean>
  hasRowHeader: Nullable<boolean>
  cells: Nullable<GuidelineRichTextDTO[][]>
  slideshowImages: Nullable<string[]>
  beforeAfterImages: Nullable<BeforeAfterImagesDTO>
}

export interface BeforeAfterImagesDTO {
  before: string
  after: string
}

export interface GuidelineRichTextDTO {
  text: string
  bold: boolean
  italic: boolean
  strikethrough: boolean
  underline: boolean
  code: boolean
  color: string
  href: Nullable<string>
}
